import { isNil } from 'ramda';

import { createTerm } from './createTerm';
import { IJsonQueryTerm } from '../../types/jsonQuery/term';

export function removeFromTerm<T>({
  jsonQuery,
  removeFromJsonQuery,
}: {
  jsonQuery: IJsonQueryTerm<T>;
  removeFromJsonQuery: IJsonQueryTerm<T>;
}) {
  const value = jsonQuery?.value;
  const removeValue = removeFromJsonQuery?.value;

  // Не удалять, если значения не равны
  if (!isNil(value) && value !== removeValue) {
    return createTerm(value);
  }

  return null;
}
